const Twitter = ({ closeApp }) => {
    return (
        <div>

            <div style={{ textAlign: 'left' }}>

                <h2 style={{ marginLeft: '40px', marginBottom: '0px', fontSize: '1.4em' }}>Twitter</h2>

                <div style={{ marginLeft: '40px', marginRight: '30px', fontSize: '0.7em' }}>
                    <br />
                    You can find me on Twitter at chriscareycode<br />
                    <a target="_blank" rel="noopener noreferer" href="https://twitter.com/chriscareycode">https://twitter.com/chriscareycode</a>

                </div>
            </div>

            

            
            <div className="app-open-close-button">
                <button onClick={closeApp}>Close</button>
            </div>
            <br />
            
        </div>
    );
};
export default Twitter;